import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../ReduxToolkit/Store';
import BusinessDash from './BusinessDash';

/*
  DASHBOARD

  Richard, 15 Oct 2026: "combine the 2 dashboards Dashboard Client and Dashboard MB into
  just one being Dashboard". One menu item; Client and MB are the two tabs at the top.
  /CRMDashboardMB still works and opens on the MB tab.
*/
/*  16 Oct 2026: Dashboard is the Property business only. The MB dashboard is under
    Mortgage Brokers (/CRMDashboardMB). */
const CRMDashboard: React.FC<{ start?: 'property' | 'managed' }> = ({ start = 'property' }) => {
    const { RoleID } = useSelector((state: RootState) => state.adminAuth);
    const isAdmin = Number(RoleID) === 1 || RoleID == null;
    const which = start;

    if (!isAdmin) {
        return <div style={{ padding: 24 }}>The dashboard is not available for this account.</div>;
    }

    return (
        <div style={{ background: '#f3f5fa', minHeight: '100%' }}>
            <BusinessDash key={which} which={which} title={which === 'managed' ? 'Mortgage Brokers' : 'Dashboard'} />
        </div>
    );
};

export default CRMDashboard;
